import styled from 'styled-components';

const Text = styled.div`
  font-size: 30px;
  margin: 40px 0;
`;

export default Text;
